<template>
    <div v-if="logined && bus.code !== 83001003">
        <el-form :inline="true" label-width="90px" class="form">
    		<el-form-item label="小程序名称">
    			<el-input v-model="filter.name" :maxlength="24"></el-input>
    		</el-form-item>
    		<el-form-item label="小程序ID">
    			<el-input v-model="filter.appId"></el-input>
    		</el-form-item>
            <btn :type="1" class="btn" info="重置" @click="reset"></btn>
            <btn :type="0" class="btn" info="搜索" @click="getList"></btn>
    	</el-form>
        <div class="list-content" v-if="!!list.length">
            <p class="total-info">共有小程序：<span class="num">{{list.length}}</span></p>
            <div class="card-list">
                <small-app-card v-for="(item, index) in list" :item="item" :key="index" class="app-card"></small-app-card>
            </div>
        </div>
        <div v-else-if="filterSearched" class="empty-info">
            搜索结果为空，请检查一下搜索条件～
        </div>
        <div v-else class="empty-info">
            暂时没有小程序
        </div>
    </div>
    <access-deny v-else></access-deny>
</template> 
<script>
import dao from '@/lib/dao.js';
import SmallAppCard from '@/components/SmallAppCard.vue';
import bus from '@/lib/bus.js';
import AccessDeny from '@/components/AccessDeny.vue';
import Btn from '@/components/Button.vue';
export default {
    components: {
        SmallAppCard,
        AccessDeny,
        Btn
    },
    data() {
        return {
            list: [],
            bus: bus,
            filter: {
                name: '',
                id: ''
            },
            logined: true,
            filterSearched: false
        }
    },
    methods: {
        getList() {
            dao.shop.getAppList(this.filter).then(data => {
                this.list = data.list || [];
                if (!this.list.length && (this.filter.name || this.filter.appId)) {
                    this.filterSearched = true;
                } else if (!this.list.length) {
                    this.filterSearched = false;
                }
            }).catch(msg => {
                this.$message.error(msg);
            });
        },
        reset() {
            this.filter = {};
            this.getList();
        }
    },
    mounted() {
        dao.shop.getCompanyInfo().then(data => {
            bus.username = data;
            bus.type = 'shop';
            this.getList();
        }).catch(response => {
            bus.code = response.code;
            if (response.code === 83001002) {
                this.logined = false;
            } else if (response.code !== 83001003) {
                this.$message.error(response.message);
            }
        });
    }
}
</script>
<style lang="less" scoped>
.form {
    .btn {
        float: right;
        margin-left: 10px;
    }
}
.list-content {
    border: 1px solid #E0E5EC;
    background: #fff;
    padding: 25px;

    .app-card {
        margin: 0 20px 20px 0;
    }

    .total-info {
        font-size: 14px;
        color: #5C667E;
        line-height: 22px;
        margin-bottom: 18px;
        .num {
            color: #212121;
            font-weight: 600;
        }
    }
}
.empty-info {
    font-size: 14px;
    color: #5C667E;
    text-align: center;
    margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/page/manage/Index.vue